import styled from 'styled-components';
import { rem } from 'polished';
import { NotReadyToBuyOnlineStyled } from '../NotReadyToBuyOnlineStyled';
export const NotReadyToBuyOnlineStyledOV = styled(NotReadyToBuyOnlineStyled)`
    background: #f5f5f5;
    border-radius: unset;

    .title {
        font-size: ${rem('22px')};
    }

    .container {
        .wrapper {
            .innerTitle {
                .titleContent {
                }
                .icon {
                    .icon-wrapper,
                    svg {
                    }
                }
            }

            .innerContent {
                color: black;
                line-height: 1.38;

                .linkButton {
                    border: unset;
                    text-align: left;
                    padding: unset;
                    font-weight: bold;
                    font-size: ${rem('16px')};
                    margin-top: ${rem('16px')};
                    color: black;
                    background: unset;
                    cursor: pointer;
                    width: fit-content;
                    position: relative;
                    display: flex;
                    flex-direction: row-reverse;

                    .txt {
                        margin-left: ${rem('7px')};
                    }

                    .icon-wrapper {
                        svg path {
                            fill: black !important;
                            stroke: black !important;
                        }
                    }

                    &:hover {
                        &:after {
                            content: '';
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: 1px;
                            background-color: ${({ theme }) => theme.colors.black};
                        }

                        .icon-wrapper {
                            svg path {
                                fill: ${({ theme }) => theme.colors.black} !important;
                                stroke: ${({ theme }) => theme.colors.black} !important;
                            }
                        }
                    }
                }

                .innerContentTxt {
                    .contentItem {
                    }
                }
            }
        }
    }
`;
